import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICategoryPartResponse, IVehicleCategoryPartsFilters } from "../models/Part";

export default function useVehicleCategoryPartsOptimized(
  vehicleId: string | undefined,
  categoryId: string | undefined,
  filters?: IVehicleCategoryPartsFilters
) {
  const { post } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 60 minutes

  const effectiveFilters: IVehicleCategoryPartsFilters = {
    includeSold: filters?.includeSold ?? true,
    limitSold: filters?.limitSold ?? 50,
    matchMake: filters?.matchMake ?? true,
    matchModel: filters?.matchModel ?? true,
    matchSeries: filters?.matchSeries ?? false,
    matchMk: filters?.matchMk ?? false,
    matchBodyStyle: filters?.matchBodyStyle ?? true,
    matchDoors: filters?.matchDoors ?? true,
    matchFuelType: filters?.matchFuelType ?? true,
    matchEngineCode: filters?.matchEngineCode ?? true,
    matchEngineSize: filters?.matchEngineSize ?? true,
    matchExactYear: filters?.matchExactYear ?? true,
    matchYearRange: filters?.matchYearRange ?? true,
    yearFrom: filters?.yearFrom,
    yearTo: filters?.yearTo,
    partStatuses: filters?.partStatuses ?? [],
  };

  const parts = useQuery({
    queryKey: ["vehicleCategoryParts", vehicleId, categoryId, effectiveFilters],
    queryFn: () =>
      post<any, ICategoryPartResponse>(
        `/part/vehicle/${vehicleId}/part-categories/${categoryId}/parts/search`,
        {
          includeSold: effectiveFilters.includeSold,
          limitSold: effectiveFilters.limitSold,
          matchMake: effectiveFilters.matchMake,
          matchModel: effectiveFilters.matchModel,
          matchSeries: effectiveFilters.matchSeries,
          matchMk: effectiveFilters.matchMk,
          matchBodyStyle: effectiveFilters.matchBodyStyle,
          matchDoors: effectiveFilters.matchDoors,
          matchFuelType: effectiveFilters.matchFuelType,
          matchEngineCode: effectiveFilters.matchEngineCode,
          matchEngineSize: effectiveFilters.matchEngineSize,
          matchExactYear: effectiveFilters.matchExactYear,
          matchYearRange: effectiveFilters.matchYearRange,
          yearFrom: effectiveFilters.yearFrom,
          yearTo: effectiveFilters.yearTo,
          partStatuses: effectiveFilters.partStatuses,
        }
      ),
    enabled: !!vehicleId && !!categoryId,
    staleTime: staleTime,
  });

  return {
    parts,
  };
}

